/* Gallery video slides (product-main, gallery_slide kind "video", 8 Oct 2026): short silent loops in the gallery.
   Loaded by product-main only when the product's gallery has a video slide.
   - A video plays while at least 60 % of it is on screen and pauses as soon as it is not (IntersectionObserver; the
     phone gallery's horizontal scroller clips, so a slide swiped away counts as out of view).
   - Never under prefers-reduced-motion or Save-Data: the poster stays. The markup has preload="none" and no autoplay,
     so a video that never plays never downloads.
   - A hidden tab pauses every video; back in view, the ones still >= 60 % visible play on.
   - Theme editor: re-binds after a section reload. */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var THRESHOLD = 0.6;
  var tracked = [];

  function blocked() {
    return (reduce && reduce.matches) || (conn && conn.saveData === true);
  }

  function play(video) {
    if (blocked() || document.hidden) return;
    video.muted = true;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function pause(video) {
    if (!video.paused) video.pause();
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      video._pmRatio = entry.isIntersecting ? entry.intersectionRatio : 0;
      if (video._pmRatio >= THRESHOLD) play(video);
      else pause(video);
    });
  }, { threshold: [0, THRESHOLD, 1] });

  function bind() {
    var videos = document.querySelectorAll('video[data-gallery-video]');
    Array.prototype.forEach.call(videos, function (video) {
      if (video._pmBound) return;
      video._pmBound = true;
      video._pmRatio = 0;
      tracked.push(video);
      io.observe(video);
    });
  }

  document.addEventListener('visibilitychange', function () {
    tracked.forEach(function (video) {
      if (document.hidden) pause(video);
      else if (video._pmRatio >= THRESHOLD) play(video);
    });
  });

  if (reduce) {
    var onChange = function () {
      if (reduce.matches) tracked.forEach(pause);
    };
    if (reduce.addEventListener) reduce.addEventListener('change', onChange);
    else if (reduce.addListener) reduce.addListener(onChange);
  }

  document.addEventListener('shopify:section:load', bind);
  bind();
})();
